import { getFlagLabelFromResponseConfig, getResponseTypeLabelFromResponseConfig } from "./responseConfigUtils";

export const getAnswerScopeLabel = (answerScope) => {
  if (answerScope === "worker") {
    return "PERSONAL";
  }

  return "SUPERVISOR";
};

export const getResponseTypeLabel = (responseConfig = {}) => {
  return getResponseTypeLabelFromResponseConfig(responseConfig);
};

export const getFlagLabel = (responseConfig = {}) => {
  return getFlagLabelFromResponseConfig(responseConfig);
};
